<template>
  <div class="dcc-proposals-cell">
    <ul class="dcc-tag-list">
      <li
        v-for="tag in allTags"
        :key="tag.value"
        class="dcc-tag"
        @click.stop="props.updateMetadataFunction(tag, props.model.documentId)"
      >
        {{ tag.label }}
        <font-awesome-icon :icon="['fas', 'check']" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { IDocumentMetadata } from 'types';
  import { DccTag } from '../../MetadataGridEditor.types';

  const props = defineProps<{
    calculateRowHeightFunction: () => void;
    model: IDocumentMetadata;
    updateMetadataFunction: (tag: DccTag, documentId: string) => void;
    labelAi: string;
    labelCheck: string;
  }>();

  const allTags = computed((): DccTag[] => {
    const proposals: DccTag[] = (props.model.dccProposals ?? []).map((v) => ({
      value: v,
      label: `${v} (${props.labelCheck})`,
      isAi: false,
    }));
    const aiPrediction = props.model.dccAiPrediction;
    const aiTag: DccTag[] = aiPrediction
      ? [
          {
            value: aiPrediction.dcc,
            label: `${aiPrediction.dcc} (${props.labelAi})`,
            isAi: true,
          },
        ]
      : [];
    return [...proposals, ...aiTag];
  });
</script>

<style lang="scss" scoped>
  .dcc-proposals-cell {
    padding: 0.5rem 0;

    .dcc-tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: 0.2rem 0.5rem;

      .dcc-tag {
        display: flex;
        align-items: center;
        gap: 0.3rem;
        background-color: $primary-color;
        border-radius: 0.125rem;
        height: 1.4rem;
        padding: 0.125rem 0.3125rem;
        font-size: 0.75rem;
        color: white;
        cursor: pointer;
        list-style: none;

        svg {
          display: none;
        }

        &:hover svg {
          display: block;
        }
      }
    }
  }
</style>
